module.exports = __webpack_public_path__ + "img/S-WEB-Goal-06.90f278f3.png";